import { useEffect, useState } from 'react';
import './App.css';
import {
    Button,
    DatePicker,
    Divider,
    Flex,
    Form,
    Input,
    message,
    Modal,
    Select,
    Upload,
} from 'antd';
import useSWR, { useSWRConfig } from 'swr';
import { Typography } from 'antd';
import { LeftCircleOutlined, PlusOutlined } from '@ant-design/icons';
import 'react-quill/dist/quill.snow.css';
import Editor from './Editor';
import { useNavigate } from 'react-router-dom';
import cookie from 'react-cookies';

const { Title } = Typography;

const fetcher = async (url: string) => {
    const res = await fetch(url, {
        headers: new Headers({
            'Access-Control-Allow-Origin': '*',
        }),
    });
    const json = await res.json();
    if (!json.success) {
        const error = new Error((await json).message);
        throw error;
    }
    return json;
};

const Manage = () => {
    const { mutate } = useSWRConfig();
    const [form] = Form.useForm();
    const [videoForm] = Form.useForm();
    const [wikiform] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [videoOpen, setVideoOpen] = useState(false);
    const [value, setValue] = useState('');
    const n = useNavigate();
    const token = cookie.load('token');

    const onCreate = async (values: any) => {
        setOpen(false);
        const formData = new FormData();
        formData.append('file', values.file.file.originFileObj);
        const response = await (
            await fetch('https://nekoda.cn/upload.php', {
                method: 'POST',
                body: formData,
                headers: new Headers({
                    'Access-Control-Allow-Origin': '*',
                }),
            })
        ).json();
        if (response.success) {
            const name = response.name;
            const formDataApi = new FormData();
            formDataApi.append('name', name);
            formDataApi.append('description', values.description);
            formDataApi.append('category_id', values.category_id);
            const apiResponse = await (
                await fetch('https://api.lynne.com.cn/manage/emotion-upload', {
                    method: 'POST',
                    body: formDataApi,
                    headers: new Headers({
                        'Access-Control-Allow-Origin': '*',
                        Authorization: `Bearer ${token}`,
                    }),
                })
            ).json();
            if (apiResponse.success) {
                message.success(apiResponse.message);
                mutate(
                    'https://api.lynne.com.cn/emotion/images?category_id=' +
                        values.category_id
                );
            } else {
                message.error(apiResponse.message);
            }
        } else {
            message.error(response.message);
        }
    };

    const onVideoCreate = async (values: any) => {
        setVideoOpen(false);
        const formData = new FormData();
        formData.append('type', values.type);
        formData.append('bvid', values.bvid);
        const response = await (
            await fetch('https://api.lynne.com.cn/manage/video-add', {
                method: 'POST',
                body: formData,
                headers: new Headers({
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${token}`,
                }),
            })
        ).json();
        if (response.success) {
            message.success(response.message);
        } else {
            message.error(response.message);
        }
    };

    const onAddWiki = async (values: any) => {
        const content = values.content;
        const date = values.date.format('YYYY-MM-DD');
        const category_id = values.category_id;
        const title = values.title;
        const response = await (
            await fetch('https://api.lynne.com.cn/manage/wiki-upload', {
                method: 'POST',
                body: JSON.stringify({
                    content,
                    date,
                    category_id,
                    title,
                }),
                headers: new Headers({
                    'Access-Control-Allow-Origin': '*',
                    'Content-type': 'Application/json',
                    Authorization: `Bearer ${token}`,
                }),
            })
        ).json();
        if (response.success) {
            message.success(response.message);
        } else {
            message.error(response.message);
        }
    };
    useEffect(() => {
        if (cookie.load('token') === undefined) {
          n('/login');
        }
      }, [n]);
    const { data, error, isLoading } = useSWR(
        'https://api.lynne.com.cn/emotion/categories',
        fetcher
    );
    const {
        data: wikiData,
        error: wikiError,
        isLoading: wikiIsLoading,
    } = useSWR('https://api.lynne.com.cn/wiki/categories', fetcher);
    if (error) return <div>failed to load</div>;
    if (isLoading) return <div>loading...</div>;
    if (wikiError) return <div>failed to load</div>;
    if (wikiIsLoading) return <div>loading...</div>;
    const categories = [];
    const wikiCategories = [];

    for (let i = 0; i < data.data.length; i++) {
        categories.push({
            value: data.data[i].id,
            label: data.data[i].category_name,
        });
    }

    for (let i = 0; i < wikiData.data.length; i++) {
        wikiCategories.push({
            value: wikiData.data[i].id,
            label: wikiData.data[i].name,
        });
    }

    // 渲染数据
    return (
        <>
        <Flex align="center" gap={10}>
        <Button
          type="primary"
          shape="circle"
          icon={<LeftCircleOutlined />}
          onClick={() => n("/dashboard")}
        />
        <Title level={3} style={{ margin: "15px 0", flex: 1 }}>
          其他管理
        </Title>
      </Flex>
            <Modal
                open={open}
                title='上传表情包'
                okText='上传'
                cancelText='取消'
                okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
                onCancel={() => setOpen(false)}
                destroyOnClose
                modalRender={dom => (
                    <Form
                        layout='vertical'
                        form={form}
                        name='upload_file'
                        clearOnDestroy
                        onFinish={values => onCreate(values)}>
                        {dom}
                    </Form>
                )}>
                <Form.Item
                    label='上传图片'
                    name='file'
                    rules={[
                        {
                            required: true,
                            message: '请上传图片',
                        },
                    ]}>
                    <Upload listType='picture-card' maxCount={1}>
                        <button
                            style={{ border: 0, background: 'none' }}
                            type='button'>
                            <PlusOutlined />
                            <div style={{ marginTop: 8 }}>Upload</div>
                        </button>
                    </Upload>
                </Form.Item>
                <Form.Item
                    name='category_id'
                    label='类别'
                    rules={[
                        {
                            required: true,
                            message: '请选择分类',
                        },
                    ]}>
                    <Select style={{ width: '100%' }} options={categories} />
                </Form.Item>
                <Form.Item
                    name='description'
                    label='描述（选填）'
                    rules={[
                        {
                            required: false,
                        },
                    ]}>
                    <Input />
                </Form.Item>
            </Modal>
            <Modal
                open={videoOpen}
                title='上传表情包'
                okText='上传'
                cancelText='取消'
                okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
                onCancel={() => setVideoOpen(false)}
                destroyOnClose
                modalRender={dom => (
                    <Form
                        layout='vertical'
                        form={videoForm}
                        name='upload_file'
                        clearOnDestroy
                        onFinish={values => onVideoCreate(values)}>
                        {dom}
                    </Form>
                )}>
                <Form.Item
                    name='type'
                    label='类别'
                    rules={[
                        {
                            required: true,
                            message: '请选择分类',
                        },
                    ]}>
                    <Select
                        style={{ width: '100%' }}
                        options={[
                            { value: 'record', label: '直播回放' },
                            { value: 'cut', label: '切片' },
                        ]}
                    />
                </Form.Item>
                <Form.Item
                    name='bvid'
                    label='BV号'
                    rules={[
                        {
                            required: true,
                        },
                    ]}>
                    <Input />
                </Form.Item>
            </Modal>
            <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
                添加表情包
            </Title>
            <Button type='primary' onClick={() => setOpen(true)}>
                添加表情包
            </Button>
            <Divider />
            <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
                添加录播/切片
            </Title>
            <Button type='primary' onClick={() => setVideoOpen(true)}>
                添加录播/切片
            </Button>
            <Divider />
            <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
                添加百科
            </Title>
            <Form
                layout='vertical'
                form={wikiform}
                name='new_wiki'
                clearOnDestroy
                onFinish={values => onAddWiki(values)}>
                <Form.Item
                    name='title'
                    label='标题'
                    rules={[
                        {
                            required: true,
                            message: '请输入标题',
                        },
                    ]}>
                    <Input />
                </Form.Item>
                <Form.Item
                    name='content'
                    label='内容'
                    rules={[
                        {
                            required: true,
                            message: '请输入内容',
                        },
                    ]}>
                    <Editor
                        placeholder={'在这里输入内容喵~'}
                        onChange={setValue}
                        value={value}
                    />
                </Form.Item>
                <Form.Item
                    name='category_id'
                    label='类别'
                    rules={[
                        {
                            required: true,
                            message: '请选择分类',
                        },
                    ]}>
                    <Select
                        mode='multiple'
                        allowClear
                        style={{ width: '100%' }}
                        placeholder='类别'
                        options={wikiCategories}
                    />
                </Form.Item>
                <Form.Item
                    name='date'
                    label='日期'
                    rules={[
                        {
                            required: true,
                            message: '请选择日期',
                        },
                    ]}>
                    <DatePicker />
                </Form.Item>
                <Button type='primary' htmlType='submit'>
                    提交
                </Button>
            </Form>
        </>
    );
};

export default Manage;
